import { freeze } from 'icepick';
import { CORE_PROJECT } from '@atlassian/jira-common-constants/src/project-types';

import { SET, type SetAction } from './actions';
import type { Project } from './types';

export type ProjectState = Project;

export const initialState: ProjectState = {
	key: '',
	id: -1,
	name: '',
	type: CORE_PROJECT,
};

type Action = SetAction;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: ProjectState = initialState, action: Action): ProjectState => {
	switch (action.type) {
		case SET: {
			return freeze(action.payload);
		}
		default:
			return state;
	}
};
